import { render, staticRenderFns } from "./score-management.vue?vue&type=template&id=dff18e18&scoped=true&"
import script from "./score-management.vue?vue&type=script&lang=js&"
export * from "./score-management.vue?vue&type=script&lang=js&"
import style0 from "./score-management.vue?vue&type=style&index=0&id=dff18e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff18e18",
  null
  
)

export default component.exports